import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { UserContext } from '../Providers/UserProvider'
import UserService from '../Services/UserService'
import useMessage from '../Hooks/useMessage'
import { Loading } from '../Components/Spinner/Loading'

export function LoginFromTempLinkContainer() {
	const { addMessage } = useMessage()
	let navigate = useNavigate()
	let params = useParams()
	const { t, i18n } = useTranslation()
	const { user, login } = useContext(UserContext)
	const { pathname } = useLocation()

	const navigateRoles = role => {
		switch (role) {
			case 'challenger':
				if (pathname.startsWith('/challenger/')) navigate(pathname)
				else navigate('/challenger/')
				break

			case 'administrator':
				if (pathname.startsWith('/admin/')) navigate(pathname)
				else navigate('/admin/statistic')
				break

			case 'system_administrator':
				if (pathname.startsWith('/sysadmin/')) navigate(pathname)
				else navigate('/sysadmin/users')
				break

			case 'technical_secretary':
				if (pathname.startsWith('/secretary/')) navigate(pathname)
				else navigate('/secretary/')
				break

			case 'expert':
				if (pathname.startsWith('/expert/')) navigate(pathname)
				else navigate('/expert/interview')
				break

			default:
				navigate('/')
				break
		}
	}

	useEffect(() => {
		if (!params.token) {
			navigate('/')
			addMessage(t('comp.noToken'), 'error')
			return
		}
		console.log(params.token)
		// e.preventDefault()
		UserService.postLoginUrl({ token: params.token }).then(
			response => {
				if (response?.data?.data) {
					login(response?.data?.data)
					localStorage.setItem(
						'bolashak_token',
						JSON.stringify(response?.data?.access_token)
					)
					addMessage(
						localStorage.getItem('i18nextLng') === 'ru' ? 'Привет!' : 'Салем!',
						'success'
					)
					navigateRoles(response?.data?.data?.roles[0])
				}
			},
			error => {
				addMessage(error?.response?.data?.error_messages, 'error')
				if (localStorage.getItem('bolashak_token')) {
					UserService.getUser().then(
						response => {
							if (response?.data) {
								login(response?.data)
								navigateRoles(response?.data?.data?.roles[0])
							}
						},
						error => {
							if (error?.response?.status === 401) {
								navigate('/')
							} else if (error?.response?.status === 500) {
								navigate('/500')
							}
							console.log('Layout error', error)
						}
					)
				}
				navigate('/')
			}
		)
	}, [])

	return <Loading />
}
